import CartIcon from "@/assets/templates/icons/cartIcon";
import Layout from "./views";
import PropTypes from "prop-types";
import { useTemplateContext } from '@/context/TemplateProvider'

const ArtStore = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Container>
      <Layout.Header>
        <Layout.HeaderContent>
          <Layout.Title >{template.logo.text}</Layout.Title>
          <Layout.IconButton>
            <CartIcon fill="#2F5A61" />
          </Layout.IconButton>
        </Layout.HeaderContent>
      </Layout.Header>
      <Layout.Content>
        <Layout.HeroTitle variant="h1">{template.sections.hero.title}</Layout.HeroTitle>
        <Layout.HeroDescription variant="body1"> {template.sections.hero.subtitle}</Layout.HeroDescription>
        <Layout.CTA>{template.sections.hero.ctaText}</Layout.CTA>
      </Layout.Content>
    </Layout.Container>
  );
};

ArtStore.propTypes = {
  config: PropTypes.object,
};
export default ArtStore;
